<template>
  <div>
    <el-dialog :title="form.id?'编辑修复方案':'新增修复方案'" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <el-form-item label="修复方案名称：" prop="name">
          <el-input v-model="form.name" placeholder="请输入修复方案" />
        </el-form-item>
        <el-form-item label="封面图：" prop="coverImage">
          <div class="flexs">
            <imageUpload v-model="form.coverImage" width="32" height="32" />
            <span class="hint hint1">限制上传1张<br />建议尺寸260x168像素以上</span>
          </div>
        </el-form-item>
        <el-form-item label="方案介绍：" class="width100">
          <el-input v-model="form.introduce" placeholder="请输入方案介绍" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="详情：" class="width100">
          <editor v-model="form.contentDetails" :min-height="240" :height="240" :uploadUrl="uploadUrl" />
        </el-form-item>
        <el-form-item label="状态：" prop="state" class="width100">
          <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch> {{form.state?'启用':'禁用'}}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import courseSubjectRepairPlanApi from '@/api/course/courseSubjectRepairPlan'
import FileUpload from "@/components/FileUpload"
import ImageUpload from "@/components/ImageUpload";
import Editor from "@/components/Editor";
function initFormBean() {
  const formBean = {
    name: null,
    coverImage: null,
    introduce: null,
    contentDetails: null,
    state: 1,
  }
  return formBean
}

export default {
  props: ['rowItem'],
  components: { Editor, ImageUpload, FileUpload },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入修复方案', trigger: 'blur' }],
        coverImage: [{ required: true, message: '请上传封面图', trigger: 'change' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()

      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row };
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.form.subjectId = this.rowItem.id
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            courseSubjectRepairPlanApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            courseSubjectRepairPlanApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }

        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
